<template>
  <div>
    <DownloadChart @click="downloadCanvas('pieChart', 'titlePieChart')" />
    <div class="p-1" ref="pieChart">
      <h3 ref="titlePieChart" class="hidden mt-4 text-lg text-center mb-4">
        {{ title }}
      </h3>
      <PieChart
        :width="width"
        :height="height"
        :chart-data="data"
        :options="options"
      />
      <div v-if="showPercentages" class="mt-3">
        <div
          v-for="(item, key) in Object.keys(reportData)"
          :key="key"
          class="flex items-center mt-2"
        >
          <div
            class="w-2 h-2 rounded-full mr-3"
            :style="'background-color: ' + legend[item] + ';'"
          ></div>
          <span class="truncate">{{ item }}</span>
          <div
            class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
          ></div>
          <span class="font-medium xl:ml-auto">
            {{ ((reportData[item] / sumTotal) * 100) | percentage }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Cases Chart"
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    reportData: {
      type: Object,
      required: true
    },
    legend: {
      type: Object,
      required: true
    },
    showPercentages: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sumTotal() {
      return Object.values(this.reportData).reduce((a, b) => a + b, 0);
    },
    indicators() {
      return Object.values(this.legend);
    },
    data() {
      return {
        labels: Object.keys(this.reportData),
        datasets: [
          {
            data: Object.values(this.reportData),
            backgroundColor: this.indicators,
            hoverBackgroundColor: this.indicators,
            borderWidth: 4,
            borderColor: this.$store.state.main.darkMode ? "#303953" : "#fff"
          }
        ]
      };
    },
    options() {
      return {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 210
      };
    }
  }
};
</script>
